import { SuccessData } from 'types/api';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { TaskSubTask } from '../types';
import { WithUsers } from 'entities/modules/users';

export const subTaskMutations = getMutations({
  createSubTask: {
    action: async (payload: {
      task: string;
      project: string;
      owner: string;
      expectedDate: string;
      name: string;
    }): Promise<WithUsers<TaskSubTask, 'owner'>> => {
      return executeApiCall({
        method: 'post',
        path: 'projects/tasks/sub-tasks',
        payload,
      });
    },

    messages: {
      suppressSuccess: true,

      error: (t) => ({
        title: t('could-not-create-sub-task'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  changeSubTaskStatus: {
    action: async (payload: {
      task: string;
      project: string;
      status: string;
      subTask: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: 'projects/tasks/sub-tasks',
        method: 'put',
        payload,
      });
    },

    messages: {
      error: (t) => ({
        title: t('could-not-change-task-status'),
        description: t('try-again-in-a-few-moments')!,
        type: 'error',
      }),
    },
  },

  changeSubTaskOwner: {
    action: async (payload: {
      task: string;
      project: string;
      subTask: string;
      owner: string;
      justification: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/projects/tasks/sub-tasks`,
        method: 'put',
        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('task-ownership-changed'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('task-ownership-error'),
        type: 'error',
      }),
    },
  },

  changeSubTaskDate: {
    action: async (payload: {
      task: string;
      project: string;
      subTask: string;
      date: string;
      justification: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/projects/tasks/sub-tasks`,
        method: 'put',
        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('date-change-request-submitted'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('could-not-request-date-change'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  changeSubTaskName: {
    action: async (payload: {
      task: string;
      project: string;
      subTask: string;
      name: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/projects/tasks/sub-tasks`,
        method: 'put',
        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('subtask-name-changed'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('subtask-name-not-changed'),
        type: 'error',
      }),
    },
  },
});
